(function () {
  const scriptSrc = document.currentScript.getAttribute('data-section');
  const scriptForm = '#' + document.currentScript.getAttribute('data-form');
  const current_section = window.document.querySelector('[id$="' + scriptSrc + '"]');

  const formMessages = () => {
    if (window.location.href.includes('?customer_posted') || window.location.href.includes('form_type=customer')) {
      let formContent = current_section.querySelector(scriptForm);
      let formWrapper = formContent.querySelector('.form-input-wrapper');
      let successMessage = formContent.querySelector('.newsletter-status-success');
      let errorMessage = formContent.querySelector('.newsletter-status-error');
      if (formWrapper) {
        formWrapper.style.display = 'none';
      }
      if (errorMessage) {
        errorMessage.style.display = 'none';
      }
      successMessage.style.display = 'block';
    }
  };
  window.addEventListener('load', function () {
    formMessages();
  });
})();